
import { IStorageAPI } from "@modules/frontend-definitions/src"


/**
 * Definition of required configuration data of the Maintenance-Mode module.
 * Allows to inject required services and APIs, so that the module itself has minimal outbound dependencies.
 */
export interface MaintenanceModeConfig {
  /** Collection of functions for interaction with a local storage. */
  storageAPI: IStorageAPI
  /** Function to log unexpected errors. */
  logUnhandledUnexpectedError: (errorMsg: string, type: any) => void
  /** Number of minutes the key is kept in local storage without interaction. */
  bypassKeyTimeout: number
  /**
   * Name of the "bypass maintenance" header.
   */
  bypassHttpHeaderName: string
  /**
   * Content of the "title" element in 503 response body JSON
   * to distinguish "normal" 503 resonses from "maintenance" ones.
   */
  maintenanceModeErrorTitle: string
}

/**
 * Configuration of the Maintenance-Mode module.
 * Not exported to not be overwritten unintentionally.
 * Get its value by calling `getMaintenanceModeConfig()`.
 */
let maintenanceModeConfig: MaintenanceModeConfig

/**
 * Initializes the Maintenance-Mode module with the given configuration.
 */
export const initializeMaintenanceModeModule = (config: MaintenanceModeConfig): void => {
  maintenanceModeConfig = config
}

/**
 * Returns the current Maintenance-Mode configuration object.
 * @returns the current Maintenance-Mode module configuration
 */
export const getMaintenanceModeConfig = (): MaintenanceModeConfig => maintenanceModeConfig
